module.exports = __webpack_public_path__ + "assets/img/49c2-so.svg";